import React from 'react';

const ProductCardLoader = ({relPd}) => {
    return (
        <div>
            <div className={`h_c_product animate-pulse  ${relPd && 'mx-2'}`}>
                <div className=''>
                    <div className='rounded-md pd-img-div h-48 w-full border-b-4 bg-slate-200'>

                    </div>
                    <div className='product-content p-2 text-center'>
                        <div>
                            <p className='rounded-xl bg-slate-200 text-slate-200'>Loading...</p>
                            <p className='rounded-xl my-2 pl-3 bg-slate-200 text-slate-200'>Loading...</p>
                            <p className='rounded-xl pl-3 bg-slate-200 text-slate-200'>Loading...</p>
                        </div>
                    </div>
                    <div className='pd-btns grid grid-cols-4 gap-x-2 p-2'>
                        <div className='rounded-xl text-center bg-slate-200 text-slate-200'>
                            <i className="fa fa-heart text-2xl" aria-hidden="true"></i>
                        </div>
                        <div className='rounded-xl bg-slate-200 text-slate-200 col-span-3 p-2 text-base font-bold text-center cursor-pointer'>
                            Loading...
                        </div>
                    </div>
                </div>
            </div >
        </div>
    );
};

export default ProductCardLoader;